import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { User, UserLevel } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppMenu',
  setup(__props) {

const route = useRoute();
const store = useStore<ShiftCMSState>();
const user = computed<User | null>(() => store.state.loggedInUser);
const language = computed<string>(() => store.getters.language);

const items = computed(() => [
  {
    title: 'Categories',
    value: 'categories',
    props: {
      to: '/categories',
      active: route.path === '/categories',
    },
  },
  {
    title: 'Users',
    value: 'users',
    props: {
      to: '/users',
      active: route.path === '/users',
    },
  },
  {
    title: 'Stories',
    value: 'stories',
    props: {
      to: '/stories',
      active: route.path === '/stories',
    },
  },
  {
    title: 'Daily Quiz',
    value: 'quiz-of-the-day',
    props: {
      to: '/quiz-of-the-day',
      active: route.path === '/quiz-of-the-day',
    },
  },
  {
    title: 'CO₂ Quiz',
    value: 'co2quiz',
    props: {
      to: '/co2quiz',
      active: route.path === '/co2quiz',
    },
  },
  {
    title: 'BTP',
    value: 'bpt',
    props: {
      to: '/bpt',
      active: route.path === '/bpt',
    },
  },
  {
    title: 'Insight',
    value: 'insight',
    props: {
      to: '/insight',
      active: route.path === '/insight',
    },
  },
  {
    title: 'Content',
    value: 'content',
    props: {
      to: '/content',
      active: route.path === '/content',
    },
  },
  {
    title: 'Learning',
    value: 'learning',
    props: {
      to: '/learning',
      active: route.path === '/learning',
    },
  },
  {
    title: 'Events',
    value: 'events',
    props: {
      to: '/events',
      active: route.path === '/events',
    },
  },
  {
    title: 'Goals',
    value: 'goals',
    props: {
      to: '/goals',
      active: route.path === '/goals',
    },
  },
  {
    title: 'Municipalities',
    value: 'municipalities',
    props: {
      to: '/municipalities',
      active: route.path === '/municipalities',
    },
  },
  {
    title: 'Locations',
    value: 'locations',
    props: {
      to: '/locations',
      active: route.path === '/locations',
    },
  },
  {
    title: 'Labels',
    value: 'labels',
    props: {
      to: '/labels',
      active: route.path === '/labels',
    },
  },
  {
    title: 'Data Tables',
    value: 'data-tables',
    props: {
      to: '/data-tables',
      active: route.path === '/data-tables',
    },
  },
  {
    title: 'Feedback',
    value: 'feedback',
    props: {
      to: '/feedback',
      active: route.path === '/feedback',
    },
  },
  {
    title: 'Statistics',
    value: 'statistics',
    props: {
      to: '/statistics',
      active: route.path === '/statistics',
    },
  },
  {
    title: 'Translations',
    value: 'translations',
    props: {
      to: '/translations',
      active: route.path === '/translations',
    },
  },
]);

const contentEditorItems = computed(() => [
  {
    title: 'Lijst',
    value: 'initiative-list',
    props: {
      to: '/initiative/list',
      active: route.path === '/initiative/list',
    },
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    app: "",
    location: "left",
    width: "140",
    permanent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list_item, {
        title: "Shift CMS",
        subtitle: language.value,
        to: "/"
      }, null, 8, ["subtitle"]),
      _createVNode(_component_v_divider),
      (user.value?.level === _unref(UserLevel).Admin)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 0,
            items: items.value
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      (user.value?.level === _unref(UserLevel).ContentEditor)
        ? (_openBlock(), _createBlock(_component_v_list, {
            key: 1,
            items: contentEditorItems.value
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})